export default "__VITE_ASSET__DiSqvIHU__"